const LoadingIndicator = () => {
  return (
    <div className="flex flex-grow justify-center items-center">
      <div className="animate-spin-slow w-8">
        <img src="/img/loading.png" alt="" />
      </div>
    </div>
  );
};
export default LoadingIndicator;
